var _effectorFileName = "/builds/gmini/front-ui-kit/src/icons/Progress.tsx";
import makeStyles from '@mui/styles/makeStyles';
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const Progress = () => {
  const classes = useStyles();
  return /*#__PURE__*/_jsx("svg", {
    className: classes.root,
    width: "13",
    height: "13",
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      d: "M11.5891 4.55301C11.2971 4.64184 11.1232 4.92957 11.1796 5.23142C11.433 6.60315 11.1324 8.13456 10.0364 9.32314C8.75799 10.7134 6.8506 11.245 5.0759 10.7127C2.09351 9.80794 0.84096 6.46284 2.23196 3.85533C3.38312 1.69739 5.94431 0.780815 8.17175 1.63614L7.60181 2.70453C5.79679 2.10173 3.7536 3.00248 3.06722 4.92597C2.53708 6.41646 3.0923 8.13942 4.38774 9.04791C6.186 10.3129 8.6322 9.68832 9.63665 7.80542C9.98934 7.14428 10.1128 6.42882 10.0399 5.73767C10.0011 5.37729 9.62351 5.15545 9.27758 5.25627L9.26947 5.25874C8.99371 5.34264 8.8283 5.61449 8.85296 5.89941C8.91072 6.5553 8.70473 7.24712 8.17539 7.79364C7.58257 8.4082 6.66678 8.66024 5.83885 8.42919C4.30286 7.99708 3.63939 6.31148 4.34758 4.98392C4.87238 4.00016 5.98671 3.5415 7.0234 3.78879L6.4196 4.92065C6.00351 4.93648 5.61419 5.15683 5.4054 5.54822C5.09503 6.13002 5.31712 6.85997 5.89891 7.17034C6.48071 7.4807 7.21066 7.25862 7.52103 6.67682C7.72982 6.28543 7.69883 5.83407 7.47742 5.48495L9.61328 1.48112C9.72332 1.27485 9.64436 1.01531 9.43809 0.905274C6.65957 -0.712827 3.01407 0.236788 1.35401 2.97933C-0.684475 6.3421 0.880394 10.7574 4.77183 11.8686C7.05818 12.5243 9.48288 11.7999 11.0349 9.99851C12.3021 8.52749 12.6672 6.68401 12.3546 5.01573C12.2915 4.66274 11.9297 4.44937 11.5891 4.55301Z",
      fill: "#4C5ECF"
    })
  });
};
const useStyles = makeStyles(() => ({
  root: {
    animation: '$circular-rotate 1.4s linear infinite'
  },
  '@keyframes circular-rotate': {
    '0%': {
      transform: 'rotate(0deg)'
    },
    '100%': {
      transform: 'rotate(360deg)'
    }
  }
}));